import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from 'vue';
import {
  StoreName,
  TUIConversationService,
  TUIStore,
} from '@tencentcloud/chat-uikit-engine';

import Server from '../ChatKit/server';
import { roomService, Theme, LanguageOption } from '../../../services';
import { hideTUIChatFeatures } from '../ChatKit/components/TUIChat/config';
import TUIChatServer from '../ChatKit/components/TUIChat/server';
// todo Remove this logic when chat is released
import MessageList from '../MessageList';
import ChatEditor from '../ChatEditor';

import { useBasicStore } from '../../../stores/basic';

export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  setup(__props) {

const TUIChat = defineAsyncComponent(
  () => import('../ChatKit/components/TUIChat/index.vue')
);

const basicStore = useBasicStore();

const defaultHideFeaturesButtons = [
  'InputFace',
  'InputStickers',
  'InputVoice',
  'InputEvaluation',
  'InputQuickReplies',
  'InputMention',
  'QuoteMessage',
  'ForwardMessage',
  'TranslateMessage',
  'VoiceToText',
  'EmojiReaction',
  'MultiSelection',
  'MessageSearch',
  'ReadStatus',
];

const currentRoomId = `GROUP${basicStore.roomId}`;

const chatKitServer = new Server();
chatKitServer.init();
new TUIChatServer();

TUIConversationService.switchConversation(currentRoomId);
hideTUIChatFeatures(defaultHideFeaturesButtons);
roomService.setTheme(basicStore.defaultTheme as Theme);
roomService.setLanguage(basicStore.lang as LanguageOption);
TUIStore.watch(StoreName.CONV, {
  currentConversationID: onCurrentConversationIDUpdate,
});

function onCurrentConversationIDUpdate(currentConversationID: string) {
  roomService.chatManager.setChatType(currentConversationID === currentRoomId);
}

return { __sfc: true,TUIChat, basicStore, defaultHideFeaturesButtons, currentRoomId, chatKitServer, onCurrentConversationIDUpdate, MessageList, ChatEditor }
}

})